import React from "react";
import Header from "../component/Header";
import { Outlet } from "react-router-dom";

export default function Quatation() {
  const navbarMenu = [
    { name: "Quotation", pageNavigate: "quotationView" },
    { name: "Quotation Add", pageNavigate: "quotationAdd " },
  ];
  return (
    <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  );
}
